export default "__VITE_ASSET__BDJzg32S__"